import { LOCALE_ISO } from '~/const/locales';
export var EXCLUDED_MAGENTO_COUNTRIES = [LOCALE_ISO['en-GB'], LOCALE_ISO['it-IT']];
export var ITALY = ['Italie', 'Italia', 'Italien', 'Italy', 'Italië', 'Itália'];
export var UNITED_KINGDOM = ['Royaume Uni', 'Regno Unito', 'Reino Unido', 'United Kingdom', 'Verenigd Koninkrijk', 'Reino Unido'];
export var NO_CREDIT_NOTE_COUNTRIES = [LOCALE_ISO['de-DE'], LOCALE_ISO['de-AT'], LOCALE_ISO['nl-NL']];